/**
 * Labstep
 *
 * @module prosemirror/components/Toolbar/ProtocolTable
 * @desc Button to insert an ProtocolTable
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { TableModal } from 'labstep-web/components/Table/Modal';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolTable } from 'labstep-web/models/protocol-table.model';
import { NodeProtocolTable } from 'labstep-web/prosemirror/nodes/protocol-table';
import { generateTableData } from 'labstep-web/services/table.service';
import type React from 'react';
import { useState } from 'react';
import type { IProtocolTableToolbarProps } from './types';

export const ProtocolTableToolbar: React.FC<
  IProtocolTableToolbarProps
> = ({ entity, dispatch, state }) => {
  const [id, setId] = useState(null);

  const { key } = NodeProtocolTable;

  const onSubmit = ({ response }: any) => {
    setId(response.result);
    const { tr } = state;
    const content = state.schema.nodes[key].create({
      id: response.entities[key][response.result].id,
      guid: response.entities[key][response.result].guid,
    });
    tr.insert(state.selection.$from.pos, content);
    if (dispatch) {
      dispatch(tr);
    }
  };

  if (!id) {
    const data = generateTableData();

    const table: any = {
      name: 'Untitled Table',
      data,
    };

    return (
      <EntityActionCreate
        entityName={ProtocolTable.entityName}
        parentName={entity.entityName}
        parentId={entity.id}
        actionComponentProps={{
          type: 'option',
          icon: 'table',
          text: 'Table',
        }}
        body={table}
        options={{ onSuccess: onSubmit }}
      />
    );
  }

  return (
    <EntityReadEntityContainer
      entityName={ProtocolTable.entityName}
      id={id}
    >
      {({ entity: protocolTable }) => (
        <TableModal
          allowLocking={
            entity.entityName === Protocol.entityName ||
            entity.isTemplate
          }
          table={protocolTable as ProtocolTable}
          viewComponent={null}
          initialModalState
          onClose={() => setId(null)}
          onDone={() => {
            setId(null);
          }}
        />
      )}
    </EntityReadEntityContainer>
  );
};
